import { FC, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SKUFormValues } from "@/lib/forms";
import { canEditSKU } from "@/lib/permissions";
import useStore from "@/state";

import { FileUploadInput } from "./file-upload-input";

export const LegitimateAttributes: FC = () => {
  const form = useFormContext<SKUFormValues>();
  const { session } = useStore();

  const lacksPermission = useMemo(() => {
    return !canEditSKU(session?.permissions);
  }, [session]);

  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="header_logo_url"
        disabled={lacksPermission}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Header Logo</FormLabel>
            <FormControl>
              <FileUploadInput fileType="image" {...field} />
            </FormControl>
            <FormDescription>
              Replace default Legitimate logo in the header of the digital
              experience. JPEG, GIF, PNG, WebP, or SVG format are supported.
            </FormDescription>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="login_type"
        disabled={lacksPermission}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Account Login Options</FormLabel>
            <Select
              onValueChange={(value) =>
                field.onChange(Number(value) as 0 | 1 | 2)
              }
              defaultValue={field.value?.toString()}
              disabled={field.disabled}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select a blockchain" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="1">
                  Email, SMS and Social (Default)
                </SelectItem>
                <SelectItem value="2">
                  Email, SMS, Social, and Wallet (Web3 Enabled)
                </SelectItem>
                <SelectItem value="0">
                  No Login (Disable Content Gating)
                </SelectItem>
              </SelectContent>
            </Select>
            <FormDescription>
              Choose how end-consumers who tap a Legitimate NFC tag will login.
            </FormDescription>
          </FormItem>
        )}
      />
    </div>
  );
};
